export default "__VITE_ASSET__BH2al2ge__"